export function getCCAAISO(ccaa: string): string | undefined {
  switch (ccaa) {
    case 'Andalucía':
      return 'ES-AN';
    case 'Aragón':
      return 'ES-AR';
    case 'Asturias':
      return 'ES-AS';
    case 'Illes Balears':
    case 'Baleares':
      return 'ES-IB';
    case 'Canarias':
      return 'ES-CN';
    case 'Cantabria':
      return 'ES-CB';
    case 'Castilla-La Mancha':
      return 'ES-CM';
    case 'Castilla Y León':
      return 'ES-CL';
    case 'Cataluña':
      return 'ES-CT';
    case 'Ceuta':
      return 'ES-CE';
    case 'Comunidad Valenciana':
      return 'ES-VC';
    case 'Extremadura':
      return 'ES-EX';
    case 'Galicia':
      return 'ES-GA';
    case 'La Rioja':
      return 'ES-RI';
    case 'Melilla':
      return 'ES-ML';
    case 'Región de Murcia':
      return 'ES-MC';
    case 'Navarra':
      return 'ES-NC';
    case 'País Vasco':
      return 'ES-PV';
    case 'Madrid':
      return 'ES-MD';
    default:
      return undefined;
  }
}

export function getStateISO(state: string): string | undefined {
  switch (state) {
    case 'Alabama':
      return 'US-AL';
    case 'Alaska':
      return 'US-AK';
    case 'Arizona':
      return 'US-AZ';
    case 'Arkansas':
      return 'US-AR';
    case 'California':
      return 'US-CA';
    case 'Colorado':
      return 'US-CO';
    case 'Connecticut':
      return 'US-CT';
    case 'Delaware':
      return 'US-DE';
    case 'Florida':
      return 'US-FL';
    case 'Georgia':
      return 'US-GA';
    case 'Hawaii':
      return 'US-HI';
    case 'Idaho':
      return 'US-ID';
    case 'Illinois':
      return 'US-IL';
    case 'Indiana':
      return 'US-IN';
    case 'Iowa':
      return 'US-IA';
    case 'Kansas':
      return 'US-KS';
    case 'Kentucky':
      return 'US-KY';
    case 'Louisiana':
      return 'US-LA';
    case 'Maine':
      return 'US-ME';
    case 'Maryland':
      return 'US-MD';
    case 'Massachusetts':
      return 'US-MA';
    case 'Michigan':
      return 'US-MI';
    case 'Minnesota':
      return 'US-MN';
    case 'Mississippi':
      return 'US-MS';
    case 'Missouri':
      return 'US-MO';
    case 'Montana':
      return 'US-MT';
    case 'Nebraska':
      return 'US-NE';
    case 'Nevada':
      return 'US-NV';
    case 'New Hampshire':
      return 'US-NH';
    case 'New Jersey':
      return 'US-NJ';
    case 'New Mexico':
      return 'US-NM';
    case 'New York':
      return 'US-NY';
    case 'North Carolina':
      return 'US-NC';
    case 'North Dakota':
      return 'US-ND';
    case 'Ohio':
      return 'US-OH';
    case 'Oklahoma':
      return 'US-OK';
    case 'Oregon':
      return 'US-OR';
    case 'Pennsylvania':
      return 'US-PA';
    case 'Rhode Island':
      return 'US-RI';
    case 'South Carolina':
      return 'US-SC';
    case 'South Dakota':
      return 'US-SD';
    case 'Tennessee':
      return 'US-TN';
    case 'Texas':
      return 'US-TX';
    case 'Utah':
      return 'US-UT';
    case 'Vermont':
      return 'US-VT';
    case 'Virginia':
      return 'US-VA';
    case 'Washington':
      return 'US-WA';
    case 'West Virginia':
      return 'US-WV';
    case 'Wisconsin':
      return 'US-WI';
    case 'Wyoming':
      return 'US-WY';
    default:
      return undefined;
  }
}
